/**
 * Forgot Password Page
 * Demande de réinitialisation de mot de passe
 */

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authService } from "../../services/authService";
import "../../styles/auth/UniversalAuth.css";

export default function ForgotPasswordUniversal() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      await authService.forgotPassword({ email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Impossible d'envoyer la demande pour le moment.";
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="universal-auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <div className="logo-icon">🌲</div>
            <h1>Naturellement Vert</h1>
          </div>
        </div>

        <div className="auth-content">
          <h2>Mot de passe oublié</h2>
          <p className="auth-subtitle">
            Entrez votre adresse email pour recevoir un lien de réinitialisation
          </p>

          {submitted ? (
            <div className="alert alert-success">
              <strong>Email envoyé !</strong>
              <p className="mt-2">
                Si un compte existe pour ce courriel, un lien de réinitialisation vous a été envoyé.
              </p>
              <p className="mt-2 text-sm">
                Vérifiez votre boîte de réception et vos spams.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              {error && (
                <div className="alert alert-error">
                  {error}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email">Adresse email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="votre@email.com"
                  data-testid="forgot-email"
                />
              </div>

              <button
                type="submit"
                disabled={submitting}
                className="btn-primary btn-full"
                data-testid="forgot-submit"
              >
                {submitting ? "Envoi en cours..." : "Envoyer le lien"}
              </button>
            </form>
          )}

          <div className="auth-footer">
            <Link to="/auth/login" className="link-secondary">
              ← Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
